import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { UpdateJobMutation } from "graphql.generated";

import { ActionSource } from "../../../state/action-sources";

export const JobStatusDropdownActions = createActionGroup({
  source: ActionSource.JOB_STATUS_DROPDOWN,
  events: {
    'Move To Next Stage Menu Item Clicked': props<{ stage: string }>(),
    'Open Job Menu Item Clicked': emptyProps(),
    'Closure Reason Menu Item Selected': props<{ closedReason: string }>(),
    'Close Job Menu Item Clicked': emptyProps(),
    'Move To Next Stage Success': props<{ updatedJob: UpdateJobMutation['updateJobs']['jobs'][0] }>(),
    'Move To Next Stage Error': props<{
      error: Error;
      customErrorMessage: string;
    }>(),
  },
})
